import React from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Select,
    TextField,
    Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';
import moment from 'moment-timezone';
import classNames from 'classnames';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import trustPilotLogo from '../../trustPilotLogo.svg';
import Tile from '../../containers/tile';
import HybridTextField from '../hybridTextField';
import { historyEntryTypesArray } from '../../constants/arrays';

const styles = (theme) => ({
    progressContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        width: 60,
    },
    progress: {
        opacity: '.5',
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    tableHead: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    paper: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    divider: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 2,
    },
    dialogDivider: {
        marginTop: theme.spacing.unit * 2.5,
        marginBottom: theme.spacing.unit * 2,
    },
    bottomBarContainer: {
        width: '100%',
        textAlign: 'right',
    },
    textButton: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: 0,
    },
    dialogActions: {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '8px 24px',
        margin: '0px 0px 0px 0px !important',
    },
    createdByFullNameField: {
        width: 350,
        marginLeft: theme.spacing.unit * 3,
    },
    createdDateField: {
        width: 120,
    },
    createdTimeField: {
        width: 120,
        marginLeft: theme.spacing.unit * 3,
    },
    tileBottomDivider: {
        marginTop: theme.spacing.unit * 3,
    },
    emailField: {
        width: 350,
    },
    rightOfFieldButton: {
        marginTop: 25,
        marginLeft: theme.spacing.unit * 3,
    },
    dialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    dialogButton: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 1,
    },
    dialogContent: {
        paddingBottom: 0,
    },
    dialogActionsDivider: {
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
    },
    formHelperText: {
        color: '#f44336',
    },
    historyContainer: {
        // maxHeight: 300,
        overflow: 'auto',
    },
    historyPaper: {
        backgroundColor: theme.palette.background.default,
        border: '1px solid #e0e0e0',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing.unit * 2,
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 1}px`,
        width: '100%',
    },
    inputLabel: {
        backgroundColor: '#fff',
        paddingLeft: 8,
        marginLeft: -5,
        paddingRight: 8,
    },
    menuFormControl: {
        marginBottom: theme.spacing.unit * 1,
        marginTop: theme.spacing.unit * 2,
    },
    bumpTop3: {
        marginTop: theme.spacing.unit * 3,
    },
    bumpTop2: {
        marginTop: theme.spacing.unit * 2,
    },
    leftField: {
        paddingRight: theme.spacing.unit * 1.5,
    },
    rightField: {
        paddingLeft: theme.spacing.unit * 1.5,
    },
    inputAdornment: {
        marginRight: 0,
    },
    important: {
        border: '1px solid #ff0000',
    },
    textFieldLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 11,
        fontWeight: 400,
        marginBottom: 4,
    },
});

class ContactReviews extends React.Component {
    state = {
        currentEntryTypeReferenceCodes: [],
        disableImportantNoteSwitch: false,
        disableNewHistoryNoteSaveButton: false,
        hideSystemNotes: false,
        showNewHistoryNoteDialog: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            historyForm: {
                ...this.state.historyForm,
                entryType: props.entryType || '',
                entryTypeReferenceCode: props.entryTypeReferenceCode || '',
                note: '',
            },
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.entryTypeReferenceCode !== this.props.entryTypeReferenceCode) {
            this.setState((state) => ({
                historyForm: {
                    ...state.historyForm,
                    entryTypeReferenceCode: this.props.entryTypeReferenceCode || '',
                },
            }));
        }
        if (prevProps.entryType !== this.props.entryType) {
            this.setState((state) => ({
                historyForm: {
                    ...state.historyForm,
                    entryType: this.props.entryType || '',
                },
            }));
        }
    }

    handleNewHistoryNoteClick = () => {
        this.setCurrentEntryTypeReferenceCodes(this.state.historyForm.entryType);
        this.setState({
            showNewHistoryNoteDialog: true,
        });
    };

    handleHideSystemNotesClick = () => {
        this.setState({
            hideSystemNotes: true,
        });
    };

    handleShowOnlyImportantNotesClick = () => {
        this.setState({
            showOnlyImportantNotes: true,
        });
    };

    handleShowSystemNotesClick = () => {
        this.setState({
            hideSystemNotes: false,
        });
    };

    handleShowAllNotesClick = () => {
        this.setState({
            showOnlyImportantNotes: false,
            hideSystemNotes: false,
        });
    };

    setCurrentEntryTypeReferenceCodes = (entryType) => {
        let currentEntryTypeReferenceCodes = [];
        switch (entryType) {
        case 'AGREEMENT': currentEntryTypeReferenceCodes = this.props.contact.agreements.map((agreement) => `RA${agreement.code}`);
            break;
        case 'SALE': currentEntryTypeReferenceCodes = this.props.contact.sales.map((sale) => `S${sale.code}`);
            break;
        case 'VISIT': currentEntryTypeReferenceCodes = this.props.contact.visits.map((visit) => `V${visit.code}`);
            break;
        case 'LEAD': currentEntryTypeReferenceCodes = this.props.contact.leads.map((lead) => `L${lead.code}`);
            break;
        case 'COMPLAINT': currentEntryTypeReferenceCodes = this.props.contact.complaints.map((complaint) => `CC${complaint.code}`);
            break;
        case 'CONTACT': currentEntryTypeReferenceCodes = [`C${this.props.contact.code}`];
            break;
        default: currentEntryTypeReferenceCodes = '';
        }

        const newEntryTypeReferenceCode = entryType ? '' : this.state.historyForm.entryTypeReferenceCode;

        this.setState((state) => ({
            currentEntryTypeReferenceCodes,
            historyForm: {
                ...state.historyForm,
                entryTypeReferenceCode: currentEntryTypeReferenceCodes.length === 1 ? currentEntryTypeReferenceCodes[0] : newEntryTypeReferenceCode,
            },
        }));
    };

    handleNewHistoryNoteCloseDialogClick = () => {
        this.setState({
            showNewHistoryNoteDialog: false,
        });
    };

    titalise = (string) => string.toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');

    capitaliseFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

    updateNewHistoryNoteData = (event) => {
        const { name, value } = event.target;
        let formattedValue;
        switch (name) {
        case 'note':
            formattedValue = this.capitaliseFirstLetter(value);
            break;
        case 'entryType':
            this.setCurrentEntryTypeReferenceCodes(value);
            formattedValue = value;
            break;
        case 'entryTypeReferenceCode':
            formattedValue = value;
            break;
        default: formattedValue = value;
            break;
        }
        event.target.value = formattedValue;
        this.setState((state) => ({
            historyForm: {
                ...state.historyForm,
                [name]: formattedValue,
            },
        }));
    };

    handleSaveNewHistoryNote = (event) => {
        event.preventDefault();
        this.setState({
            disableNewHistoryNoteSaveButton: true,
        });
        this.props.addNewHistoryNote(this.state.historyForm).then(() => {
            this.setState({
                disableNewHistoryNoteSaveButton: false,
                showNewHistoryNoteDialog: false,
            });
            this.props.enqueueSnackbar('History note saved', { variant: 'success' });
        }).catch(() => {
            this.props.enqueueSnackbar('History note save failed', { variant: 'error' });
            this.setState({
                disableNewHistoryNoteSaveButton: false,
            });
        });
    };

    handleImportantNoteSwitchClick = async (contactHistoryCode) => {
        this.setState((state) => ({
            disableImportantNoteSwitch: true,
        }));
        this.importantNoteToggle(contactHistoryCode);
    };

    importantNoteToggle = (contactHistoryCode) => {
        const entry = this.props.histories.find((e) => e.code === contactHistoryCode);
        const newState = !entry.alert;
        const payload = {
            alert: newState,
        };
        this.props.updateHistoryNote(contactHistoryCode, payload).then(() => {
            this.setState({
                disableImportantNoteSwitch: false,
            });
            this.props.enqueueSnackbar('Important Note Status Set', { variant: 'success' });
        }).catch(() => {
            this.props.enqueueSnackbar('Set Important Note Status Failed', { variant: 'error' });
            this.setState({
                disableImportantNoteSwitch: false,
            });
        });
    };

    render() {
        const {
            classes,
            contact,
            contactLoading,
            contactTrustPilotReviewsLoading,
            errors,
            fetchTrustPilotReviewsData,
            reviews,
            tileTitlePostfix = '',
        } = this.props;
        const {
            currentEntryTypeReferenceCodes,
            disableImportantNoteSwitch,
            disableNewHistoryNoteSaveButton,
            hideSystemNotes,
            historyForm,
            showNewHistoryNoteDialog,
            showOnlyImportantNotes,
        } = this.state;

        // let currentEntryTypeReferenceCodes = [];
        // if (!contactLoading && contact && contact.agreements) {
        //     switch (historyForm.entryType) {
        //     case 'AGREEMENT': currentEntryTypeReferenceCodes = contact.agreements.map(agreement => `RA${agreement.code}`);
        //         break;
        //     case 'VISIT': currentEntryTypeReferenceCodes = contact.visits.map(visit => `V${visit.code}`);
        //         break;
        //     case 'LEAD': currentEntryTypeReferenceCodes = contact.leads.map(lead => `L${lead.code}`);
        //         break;
        //     case 'CONTACT': currentEntryTypeReferenceCodes = [`C${contact.code}`];
        //         break;
        //     default: currentEntryTypeReferenceCodes = '';
        //     }
        //     if (currentEntryTypeReferenceCodes.length === 1) {
        //         this.setState(state => ({
        //             historyForm: {
        //                 ...state.historyForm,
        //                 entryTypeReferenceCode: currentEntryTypeReferenceCodes[0],
        //             },
        //         }));
        //     }
        // }

        // console.log('>>> currentEntryTypeReferenceCodes:', currentEntryTypeReferenceCodes);

        return (
            <Tile
                tileTitle="Reviews"
                refreshAction={fetchTrustPilotReviewsData}
                refreshing={contactTrustPilotReviewsLoading}
                // tileMenuItems={[
                //     {
                //         action: this.handleNewHistoryNoteClick,
                //         disabled: (contactLoading && !contact && !contact.agreements),
                //         label: 'New Entry',
                //         section: 1,
                //     },
                //     {
                //         action: hideSystemNotes ? this.handleShowSystemNotesClick : this.handleHideSystemNotesClick,
                //         disabled: (contactLoading && !contact && !contact.agreements),
                //         label: `${hideSystemNotes ? 'Show System Notes' : 'Hide System Notes'}`,
                //         section: 2,
                //     },
                //     {
                //         action: this.handleShowOnlyImportantNotesClick,
                //         disabled: (contactLoading && (!contact || !contact.agreements)) || (showOnlyImportantNotes),
                //         label: 'Show Only Important Notes',
                //         section: 2,
                //     },
                //     {
                //         action: this.handleShowAllNotesClick,
                //         disabled: (contactLoading && (!contact || !contact.agreements)) || (!showOnlyImportantNotes && !hideSystemNotes),
                //         label: 'Show All Notes',
                //         section: 2,
                //     },
                // ]}
                style
            >
                { !contactLoading && !contactTrustPilotReviewsLoading
                    ? (

                        <div className={classes.historyContainer}>
                            <Grid container spacing={0}>
                                {reviews.length === 0 && (
                                    <Typography variant="body1">
                                        No Reviews found
                                    </Typography>
                                )}

                                {reviews.sort((a, b) => b.createdDateTime.localeCompare(a.createdDateTime)).map((entry) => (
                                    <Paper
                                        className={classNames(
                                            classes.historyPaper,
                                            {
                                                [classes.important]: entry.alert,
                                            },
                                        )}
                                        elevation={0}
                                        key={entry.code}
                                    >
                                        <Grid
                                            container
                                            spacing={0}
                                        >
                                            <Grid item xs={4} style={{ paddingBottom: 16 }}>
                                                <div className={classes.textFieldLabel}>
                                                    Rating
                                                </div>
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    star <= entry.stars
                                                        ? <StarIcon key={star} style={{ color: '#F9AA33', fontSize: 32 }} />
                                                        : <StarBorderIcon key={star} style={{ color: '#F9AA33', fontSize: 32 }} />
                                                ))}
                                            </Grid>
                                            <Grid item xs={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <img src={trustPilotLogo} alt="Trustpilot" style={{ backgroundColor: '#000000', height: 40, padding: 8 }} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <HybridTextField
                                                    label="Title"
                                                    text={entry.title}
                                                    alert={entry.alert}
                                                    title
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <HybridTextField
                                                    label="Body"
                                                    text={entry.text}
                                                    alert={entry.alert}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}
                                        >
                                            <Grid item xs={12}>
                                                <HybridTextField
                                                    label="Source"
                                                    text="TrustPilot"
                                                    extlink={`https://www.trustpilot.com/reviews/${entry.id}`}
                                                    alert={entry.alert}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            spacing={0}
                                        >
                                            <Grid item xs={2}>
                                                <HybridTextField
                                                    label="Date"
                                                    text={moment(entry.createdDateTime).format('DD/MM/YYYY')}
                                                    alert={entry.alert}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <HybridTextField
                                                    label="Time"
                                                    text={moment(entry.createdDateTime).format('HH:mm')}
                                                    alert={entry.alert}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <HybridTextField
                                                    label="Created By"
                                                    text={entry.createdByContact}
                                                    link={`/contact/${entry.createdByContactCode}`}
                                                    alert={entry.alert}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                ))}
                            </Grid>
                        </div>
                    )
                    : (
                        <div className={classes.progressContainer}>
                            <CircularProgress className={classes.progress} variant="indeterminate" />
                        </div>
                    )}
            </Tile>
        );
    }
}

export default withSnackbar(withStyles(styles)(ContactReviews));
